export enum AddItemEnum {
  Card = 'CARD',
  Account = 'ACCOUNT',
}
